<!--
    描述：项目管理 -- 待审核项目- 租凭通
    时间：2022-07-25
    Created by 李家宝
-->
<template>
  <div class="juyi-project-msg-main">
    <div class="expert-content">
      <el-form
        :model="zulinProjectMsg"
        label-width="170px"
        size="small"
        ref="personForm"
        :show-message="false"
      >
        <el-row class="mb20">
          <el-col :span="24">
            <h3>{{ zulinProjectMsg.sname }}</h3>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle">
          <el-col :span="19" :offset="1">
            <el-steps :active="active" align-center>
              <el-step
                v-for="(item, index) in stepList"
                :key="item.id"
                :title="item.stageTypeName"
              ></el-step>
            </el-steps>
          </el-col>
          <!-- <el-col :span="5">
            <img
              v-if="rowData.statusName == '交易中'"
              style="width: 143px; height: 111px;margin-left: 80px"
              src="../../../../assets/images/transaction.png"
            />
            <img
              v-if="rowData.statusName == '交易完成'"
              style="width: 143px; height: 111px;margin-left: 80px"
              src="../../../../assets/images/transaction_wancheng.png"
            />
          </el-col> -->
        </el-row>
        <el-row class="mt20">
          <el-col :span="24">
            <el-form-item>
              <span slot="label">
                <span class="blacktext">当前状态：</span>
              </span>
              <div class="bluetext">
                {{ zulinProjectMsg.rentSeekStatusName }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发布时间：">
              {{ zulinProjectMsg.pubReleaseTime | dateFilter }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="期望产品入场时间：">
              <span class="redtext">
                {{ zulinProjectMsg.mobilizationTime }}</span
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入场地址：">
              {{ zulinProjectMsg.projectProvinceName
              }}{{ zulinProjectMsg.projectCityName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址：">
              {{ zulinProjectMsg.detailAddress }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付款方式：">
              {{ zulinProjectMsg.paymentMethodName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工期长度：">
              {{ zulinProjectMsg.durationLengthName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否采用电子合同：">
              {{
                zulinProjectMsg.electronicContractFlag === 0
                  ? "不选择"
                  : zulinProjectMsg.electronicContractFlag === 1
                  ? "不采用"
                  : "采用"
              }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票类型：">
              {{
                zulinProjectMsg.isInvoice === 0
                  ? "不选择"
                  : zulinProjectMsg.isInvoice === 1
                  ? "增值税普票"
                  : "增值税专票"
              }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否需支付报价保证金：">
              {{
                zulinProjectMsg.bondFlag === 0
                  ? "不选择"
                  : zulinProjectMsg.bondFlag === 1
                  ? "不需要"
                  : "需要"
              }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式：">
              <div style="display: flex;align-items: center">
                <span>{{ phone }}</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="isShow ? '点击显示手机号' : '点击隐藏手机号'"
                  placement="top-start"
                >
                  <img
                    v-if="isShow"
                    @click="isShowPhone"
                    class="icon"
                    src="../../../../assets/images/display.png"
                  />
                  <img
                    v-else
                    @click="isShowPhone"
                    class="icon"
                    src="../../../../assets/images/hide.png"
                  />
                </el-tooltip>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同模板：">
              <div v-if="zulinProjectMsg.contractTemplateUrl != ''">
                <el-button type="text" @click="doView">
                  {{ zulinProjectMsg.contractTemplateName }}{{ fileSuffixName }}
                </el-button>
                <el-button type="text" @click="doView" style="color: #FF6600"
                  >查看</el-button
                >
                <el-button
                  type="text"
                  @click="doDownload"
                  style="color: #FF6600"
                  >下载</el-button
                >
              </div>
              <div v-else><el-button type="text">暂无附件</el-button></div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="求租截止时间：">
              <span class="redtext">{{ zulinProjectMsg.deadline }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="项目描述：">
              <p
                style="width: 64%;font-size:14px;font-family: Avenir, Helvetica, Arial, sans-serif;white-space:pre-wrap;word-break:break-all;"
              >
                {{ zulinProjectMsg.projectDes }}
              </p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="产品类别：">
              {{ productObj.productCategoryName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="品牌：">
              {{ productObj.brand }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规格：">
              {{ productObj.categorySpecification }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="型号：">
              {{ productObj.categoryModel }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="数量：">
              {{ productObj.categoryNum }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计量单位：">
              {{ productObj.unit }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注说明：">
              <p
                style="width: 64%;font-size:14px;font-family: Avenir, Helvetica, Arial, sans-serif;white-space:pre-wrap;word-break:break-all;"
              >
                {{ productObj.remarks }}
              </p>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  zulingetRelationList,
  zulinselectProjectById
} from "api/modules/projectManagement";
import VUE_CONFIG from "../../../../../vue.config";
import { downloadFile } from "../../../../utils/tools";

export default {
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    audit: {
      type: String,
      default: ""
    }
  },
  filters: {
    dateFilter(time) {
      return bmTooljs.dateformat(new Date(time), "yyyy-MM-dd");
    }
  },
  computed: {
    ...mapState("dict", {
      projectDict: state => state.projectDict
    }),

    ...mapState("user", ["userInfo"]),

    // 获取文件后缀名
    fileSuffixName() {
      const fileURL = this.zulinProjectMsg.contractTemplateUrl || "";
      return fileURL.substring(fileURL.lastIndexOf("."));
    },

    // 上传接口地址
    uploadUrl() {
      let uploadUrl = "";
      // 本地环境代理后无法直接获取路径
      if (process.env.VUE_APP_UPLOAD_URL == "/uploadApi") {
        uploadUrl = VUE_CONFIG.devServer.proxy["/uploadApi"].target;
      } else {
        uploadUrl = process.env.VUE_APP_UPLOAD_URL;
      }
      return uploadUrl;
    }
  },
  data() {
    return {
      zulinProjectMsg: {
        id: "",
        baseId: "",
        businessId: ""
      },
      productObj: {}, //求租产品详情
      phone: "", // 联系方式
      active: 0, // 步骤条当前索引
      stepList: [], // 步骤条数据
      isShow: true // 控制显示icon
    };
  },
  created() {
    if (!this.rowData.id) {
      this.$router.push({
        name: "to-audit-proJect-list"
      });
      return;
    }
    //数据加载
    this.zulinselectProjectById();
    this.zulingetRelationList();
    if (this.audit === "view") {
      //操作记录
      this.getProjectAuditLog();
    }
  },
  methods: {
    // 下载文件
    doDownload() {
      downloadFile(
        this.uploadUrl + this.zulinProjectMsg.contractTemplateUrl,
        this.zulinProjectMsg.contractTemplateName + this.fileSuffixName
      );
    },

    // 查看文件
    doView() {
      window.open(
        this.$previewUrl +
          process.env.VUE_APP_ZLT_UPLOAD_URL +
          this.zulinProjectMsg.contractTemplateUrl,
        "_blank"
      );
    },

    // 是否显示手机号
    isShowPhone() {
      this.isShow = !this.isShow;
      if (this.isShow) {
        this.phone = this.phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
      } else {
        this.phone = this.zulinProjectMsg.linkPhone;
      }
    },

    // 获取步骤条
    zulingetRelationList() {
      zulingetRelationList({
        busId: this.rowData.id,
        currentUserId: this.userInfo.id
      }).then(res => {
        if (res.code == 0) {
          this.stepList = res.data;
          this.stepList.forEach((item, index) => {
            if (item.signStatus == 1) {
              // this.active += 1;
              this.active = index + 1;
            }
          });
        }
      });
    },

    //获取租赁通项目
    zulinselectProjectById() {
      zulinselectProjectById({
        id: this.rowData.id,
        currentUserId: this.userInfo.id
      }).then(res => {
        if (res.operationCode == "1") {
          this.zulinProjectMsg = res.data;
          this.productObj =
            this.zulinProjectMsg.productList.length == 0
              ? ""
              : this.zulinProjectMsg.productList[0];
          this.phone = res.data.linkPhone.replace(
            /(\d{3})\d{4}(\d{4})/,
            "$1****$2"
          );
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
.juyi-project-msg-main {
  height: 100%;
  .expert-content {
    background-color: #fff;
    padding: 20px;
    .numblerbox {
      padding: 20px 80px;
      display: flex;
    }
  }
}
.icon {
  width: 25px;
  margin-left: 10px;
  cursor: pointer;
}
.redtext {
  color: #ff0000;
}

.bluetext {
  color: #0000ff;
  font-weight: 600;
}
.blacktext {
  color: #000;
  font-weight: 600;
}
</style>
